import React from 'react';
import { connect } from 'react-redux';
import { branch, compose, renderComponent } from 'recompose';

import TicketTable from './TicketTable';

import { queryAllTicketsGQL } from '../graphql/allTicketsApi';
import {
  getBeforePageSize,
  getDepartmentId,
  getDistrictId,
  getFirstPageSize, getLeaseId,
  getNextCursor, getOperatorId,
  getPageSize,
  getPrevCursor,
  getJobTicketNumber,
  getSorted,
} from '../selectors';
import { setNextCursor, setPageSize, setPrevCursor, setTableOrder } from '../actions';

const mapStateToProps = (state) => {
  return {
    jobTicketNumber: getJobTicketNumber(state),
    departmentId: getDepartmentId(state),
    districtId: getDistrictId(state),
    currentPageSize: getPageSize(state),
    nextCursor: getNextCursor(state),
    prevCursor: getPrevCursor(state),
    first: getFirstPageSize(state),
    last: getBeforePageSize(state),
    sorted: getSorted(state),

    /* NOTE: used in query */
    operatorId: getOperatorId(state),
    leaseId: getLeaseId(state),
  };
};

const mapDispatchToProps = {
  setPageSizeAction: setPageSize,
  setNextCursorAction: setNextCursor,
  setPrevCursorAction: setPrevCursor,
  setTableOrderAction: setTableOrder,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withNoFilteringValues = branch(
  (props) => {
    const { jobTicketNumber, departmentId, districtId, operatorId, leaseId } = props;
    return (!jobTicketNumber && !departmentId && !districtId && !operatorId && !leaseId);
  },
  renderComponent(() => {
    return (
      <div className="panel-body" style={{ textAlign: 'center' }}>
        <h4>Empty</h4>
        <p className="text-muted">No Filtering Values Where Selected</p>
      </div>
    );
  }),
);

const enhance = compose(
  withRedux,
  withNoFilteringValues,
  queryAllTicketsGQL,
);

export default enhance(TicketTable);
